import { getUsersUnsubscribeFromTopic } from './getUsersUnsubscribeFromTopic'
import { isSupported } from 'firebase/messaging'

export const unsubscribeToTopic = async (topic, registrationTokens) => {
  if (isSupported) {
    await getUsersUnsubscribeFromTopic({ topic, registrationTokens })
  }
} // unsubscribe to topics
